// extracted by mini-css-extract-plugin
module.exports = {"errorContainer":"styles_errorContainer__qipg6","button":"styles_button__1sIx_","details":"styles_details__D9W_1"};